import { render, staticRenderFns } from "./NewOrdersCSV.vue?vue&type=template&id=079dfb82&scoped=true&"
import script from "./NewOrdersCSV.vue?vue&type=script&lang=js&"
export * from "./NewOrdersCSV.vue?vue&type=script&lang=js&"
import style0 from "./NewOrdersCSV.vue?vue&type=style&index=0&id=079dfb82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079dfb82",
  null
  
)

export default component.exports